function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var BrandContact=
function BrandContact(firstName,lastName,email,phone){_classCallCheck(this,BrandContact);
this.firstName=firstName;
this.lastName=lastName;
this.email=email;
this.phone=phone;
this.isActive=true;
};


export default BrandContact;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9tb2RlbHMvQnJhbmRDb250YWN0LmpzIl0sIm5hbWVzIjpbIkJyYW5kQ29udGFjdCIsImZpcnN0TmFtZSIsImxhc3ROYW1lIiwiZW1haWwiLCJwaG9uZSIsImlzQWN0aXZlIl0sIm1hcHBpbmdzIjoib0pBQU1BLGE7QUFDSixzQkFBWUMsU0FBWixDQUF1QkMsUUFBdkIsQ0FBaUNDLEtBQWpDLENBQXdDQyxLQUF4QyxDQUErQztBQUM3QyxLQUFLSCxTQUFMLENBQWlCQSxTQUFqQjtBQUNBLEtBQUtDLFFBQUwsQ0FBZ0JBLFFBQWhCO0FBQ0EsS0FBS0MsS0FBTCxDQUFhQSxLQUFiO0FBQ0EsS0FBS0MsS0FBTCxDQUFhQSxLQUFiO0FBQ0EsS0FBS0MsUUFBTCxDQUFnQixJQUFoQjtBQUNELEM7OztBQUdILGNBQWVMLGFBQWYiLCJmaWxlIjoiQnJhbmRDb250YWN0LmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJjbGFzcyBCcmFuZENvbnRhY3Qge1xuICBjb25zdHJ1Y3RvcihmaXJzdE5hbWUsIGxhc3ROYW1lLCBlbWFpbCwgcGhvbmUpIHtcbiAgICB0aGlzLmZpcnN0TmFtZSA9IGZpcnN0TmFtZTtcbiAgICB0aGlzLmxhc3ROYW1lID0gbGFzdE5hbWU7XG4gICAgdGhpcy5lbWFpbCA9IGVtYWlsO1xuICAgIHRoaXMucGhvbmUgPSBwaG9uZTtcbiAgICB0aGlzLmlzQWN0aXZlID0gdHJ1ZTtcbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBCcmFuZENvbnRhY3Q7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/models/BrandContact.js
// module id = 820
// module chunks = 0